"use client";

import { NextUIProvider } from "@nextui-org/react";
export default function TheNextUIProviders({
  children
}: {
  children: React.ReactNode;
}) {
  return <NextUIProvider data-sentry-element="NextUIProvider" data-sentry-component="TheNextUIProviders" data-sentry-source-file="index.tsx">{children}</NextUIProvider>;
}